import React, { useState } from 'react';
import './ContactSection.css';

// Constants
const SUCCESS_MESSAGE_DURATION = 3000; // Duration in milliseconds before clearing form and hiding success message

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    const web3formsAccessKey = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;
    
    if (!web3formsAccessKey) {
      setError('Error de configuración. Por favor, contacte al administrador.');
      setLoading(false);
      return;
    }
    
    try {
      // Prepare the form data for Web3Forms
      const formPayload = {
        access_key: web3formsAccessKey,
        name: formData.name,
        email: formData.email,
        phone: formData.phone || 'No proporcionado',
        message: formData.message,
        subject: `ARG Pagina Web - ${formData.name}`,
        from_name: 'Alicea Realty Group Website',
      };
      
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formPayload)
      });
      
      const result = await response.json();
      
      if (result.success) {
        setSubmitted(true);
        setTimeout(() => {
          setSubmitted(false);
          setFormData({ name: '', email: '', phone: '', message: '' });
        }, SUCCESS_MESSAGE_DURATION);
      } else {
        setError('Hubo un problema al enviar el mensaje. Por favor, intente nuevamente.');
      }
    } catch (err) {
      console.error('Form submission error:', err);
      setError('Error al enviar el mensaje. Por favor, verifique su conexión e intente nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-section-container">
        <div className="contact-section-header">
          <h2>¡Oriéntese Hoy!</h2>
          {/* <p>Contáctenos hoy y estaremos encantados de ayudarle</p> */}
        </div>

        <div className="contact-section-content">
          {/* Contact Information */}
          <div className="contact-section-info">
            <div className="contact-info-card">
              <div className="contact-info-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                  <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                </svg>
              </div>
              <h3>Correo Electrónico</h3>
              <a href="mailto:alicearealtygroupllc@gmail.com">alicearealtygroupllc@gmail.com</a>
            </div>

            <div className="contact-info-card">
              <div className="contact-info-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path fillRule="evenodd" d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z" clipRule="evenodd" />
                </svg>
              </div>
              <h3>Teléfono</h3>
              <a href="tel:+17873421648">(787) 342-1648</a>
            </div>

            {/* <div className="contact-info-card">
              <div className="contact-info-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z" clipRule="evenodd" />
                </svg>
              </div>
              <h3>Horario de Atención</h3>
              <p>Lunes - Domingo</p>
              <p className="hours-detail">Disponibles 24/7</p>
            </div> */}
          </div>

          {/* Contact Form */}
          <div className="contact-section-form">
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="contact-name">Nombre *</label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Su nombre completo"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact-email">Correo Electrónico *</label>
                  <input
                    type="email"
                    id="contact-email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="su@email.com"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="contact-phone">Teléfono</label>
                <input
                  type="tel"
                  id="contact-phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="(787) 123-4567"
                />
              </div>

              <div className="form-group">
                <label htmlFor="contact-message">Mensaje *</label>
                <textarea
                  id="contact-message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Cuéntenos sobre su propiedad ideal..."
                  required
                ></textarea>
              </div>

              <button type="submit" className="contact-submit-button" disabled={loading}>
                <span>{loading ? 'Enviando...' : 'Enviar Mensaje'}</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" />
                </svg>
              </button>

              {error && (
                <div className="error-message-banner">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path fillRule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clipRule="evenodd" />
                  </svg>
                  {error}
                </div>
              )}

              {submitted && (
                <div className="success-message-banner">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
                  </svg>
                  ¡Gracias! Su mensaje ha sido enviado exitosamente.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
